module.exports = __webpack_public_path__ + "d13f0184a91bce983aa726c465afea9f.svg";